import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NsnPipe } from './pipes/nsn.pipe';
import { ButtonModule } from 'primeng/button';
import {
  SustainmentComponentModule,
  WINDOW_PROVIDER
} from 'sustainment-component';
import { FilterCompaniesPipe } from './pipes/companies-chat.pipe';
import { FilterProjectMembersPipe } from './components/features/dashboard/project-filter.pipe';
import { ProjectOpportunityChannelSortPipe } from './components/features/dashboard/project-channel-sort.pipe';
import { MainSpinnerModule } from './components/ui/main-spinner/main-spinner.module';
import { ContentExplorerModule } from './components/ui/content-explorer/content-explorer.module';
import { ContentPreviewModule } from './components/ui/content-preview/content-preview.module';

@NgModule({
  declarations: [
    NsnPipe,
    FilterCompaniesPipe,
    FilterProjectMembersPipe,
    ProjectOpportunityChannelSortPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    ReactiveFormsModule,
    NsnPipe,
    SustainmentComponentModule,
    FilterCompaniesPipe,
    FilterProjectMembersPipe,
    ProjectOpportunityChannelSortPipe,
    MainSpinnerModule,
    ContentExplorerModule,
    ContentPreviewModule
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    SustainmentComponentModule
  ],
  providers: [WINDOW_PROVIDER, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
